import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { fetchCarsDiffThanEntrega, fetchCarsNoPagination } from '../../../api/carsApi';
import { queryKeys } from '../queryKeys';

/**
 * at-130: `refetchInterval` opcional — o Telão em tela cheia (`/telao`) recarrega a cada 60 s
 * além do socket, porque na TV ninguém recarrega a página e um socket perdido deixaria o quadro
 * velho indefinidamente. A Home segue sem intervalo.
 */
export const useHomeCarsQuery = (opcoes: { refetchInterval?: number | false } = {}) => {
  return useQuery({
    queryKey: queryKeys.cars.queue({ context: 'home-no-pagination' }),
    queryFn: () => fetchCarsNoPagination(),
    staleTime: 60_000,
    placeholderData: keepPreviousData,
    refetchInterval: opcoes.refetchInterval ?? false,
  });
};

export const useHomeNonEntregaSummaryQuery = () => {
  return useQuery({
    queryKey: queryKeys.cars.queue({ context: 'home-non-entrega-summary' }),
    queryFn: () => fetchCarsDiffThanEntrega(1, 1),
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
};
